import { useMemo, useState } from "react";

import { EmailModalContext } from "./EmailModalContext";

function EmailModalProvider({ children }: { children: React.ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);

  const value = useMemo(() => ({ isOpen, setIsOpen }), [isOpen]);

  return <EmailModalContext.Provider value={value}>{children}</EmailModalContext.Provider>;
}

export default EmailModalProvider;

